<template>
  <div id="app">
    <KaerPage :props="pageConfig" :shareData="shareData">
      <div class="back-to-top" v-if="pageConfig.showToTop" v-show="showBackTop" @click="goBackTop"></div>

      <div
        class="rule-btn"
        v-if="pageConfig.ruleText"
        :style="{
          top: `${rulePadding}px`
        }"
        @click="showRuleText = true"
      >
        活动规则
      </div>
      <van-popup v-model="showRuleText" class="rule-text-popup">
        <div class="rule-text-card">
          <div class="rule-text-header">活动规则</div>
          <div
            class="rule-text-content"
            v-html="pageConfig.ruleText && pageConfig.ruleText.replace(/\n|\r\n/g, '<br>')"
          ></div>
        </div>
        <div class="rule-text-close" @click="showRuleText = false"></div>
      </van-popup>

      <!-- 解决外边距溢出问题 -->
      <table></table>
      <kaer-component @init="getPageData">
        <kaer-image-single />
        <!-- <kaer-rich-text></kaer-rich-text> -->
      </kaer-component>
    </KaerPage>
  </div>
</template>
<script>
import { env } from '@/config';
import VueScrollTo from 'vue-scrollto';
import KaerHeader from './components/header/index.vue';
import KaerImageSingle from './components/kaer-image-single/index.vue';
import KaerPage from './components/page/index.vue';
import KaerRichText from './components/kaer-rich-text';

export default {
  components: {
    KaerHeader,
    KaerPage,
    KaerImageSingle,
    KaerRichText
  },
  data() {
    return {
      pageConfig: {},
      headerConfig: {},
      shareData: {},
      opacity: 0,
      showBackTop: false,
      showRuleText: false,
      isMock: env === 'mock'
    };
  },
  computed: {
    rulePadding() {
      // 44 header高度 + 8 间距
      return this.adapt.getPaddingTop() + 44 + 8;
    },
    headerPaddingTop() {
      return this.adapt.getPaddingTop() + 44;
    }
  },
  methods: {
    getPageData(pageData) {
      console.log('getPageData', pageData);
      this.pageConfig = pageData;
      this.headerConfig = pageData.headerConfig || {};

      // 活动下架
      if (pageData.showPage === false) {
        this.$dialog
          .alert({
            className: 'zy-custom-dialog',
            title: '抱歉，来晚了',
            message: '您查看的活动已结束。',
            confirmButtonText: '我知道了'
          })
          .then(this.$goBack);
      }

      pageData.headerConfig.title && this.adapt.setTitle(pageData.headerConfig.title);
      // 设置分享
      this.setShareData();
      if (pageData.hideWxShare) {
        this.adapt.hideAllNonBaseMenuItem();
      }
      const pageId = window.__kaer_config__?.config?.pageId;
      this.uploadData(pageId || 'TMS-page', 'page', { title: pageData.title, url: window.location.href });
    },
    setShareData() {
      const { showShare, shareConfig = {} } = this.headerConfig;
      if (!showShare || !Object.keys(shareConfig).length) return;
      this.shareData = {
        title: shareConfig.title,
        content: shareConfig.content,
        link: shareConfig.link || window.location.href,
        imageUrl: shareConfig.imageUrl || 'http://static.91jkys.com/activity/img/d3a997de75364ca1a5d81ad9065d5567.png'
      };

      // 设置小程序分享
      if (this.env.inWechatMiniProgram) {
        wx.miniProgram.postMessage({
          data: {
            title: this.shareData.title,
            pageUrl: window.location.href,
            shareUrl: encodeURIComponent(this.shareData.link), // 自定义分享链接
            imageUrl: encodeURIComponent(this.shareData.imageUrl),
            isNeedLogin: 0 // 小程序默认 1
            // trackId: string 埋点id
          }
        });
      } else {
        // 设置 app、微信分享
        this.adapt.setShareConfig(this.shareData);
      }
    },
    goBackTop() {
      VueScrollTo.scrollTo(document.getElementsByTagName('body')[0], 300);
    }
  }
};
</script>
<style lang="scss">
body {
  background: #f5f5f5;
}

.van-popup {
  background-color: transparent !important;
}

#app {
  height: 100vh;
  position: relative;

  .back-to-top {
    width: 44px;
    height: 44px;
    background-image: url('~@/assets/back-top-icon.png');
    background-size: 100%;
    position: fixed;
    bottom: 80px;
    right: 12px;
    z-index: 99;
  }

  .rule-btn {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    padding: 0 8px;
    position: absolute;
    right: 12px;
  }

  .rule-text-card {
    background-color: #fff;
    border-radius: 6px;
    width: 280px;
    padding: 20px;
    .rule-text-header {
      color: #262626;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 12px;
      text-align: center;
    }
    .rule-text-content {
      max-height: 260px;
      overflow-y: scroll;
    }
  }

  .rule-text-close {
    width: 28px;
    height: 28px;
    background-image: url('~@/assets/rule-close-icon.png');
    background-size: 100%;
    margin-top: 16px;
    margin-left: calc(50% - 14px);
  }
}
</style>
